<template>
  <div id="certificate-addorupdate">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-input size="medium" v-model="canvas.title" :disabled="loading || backgroundLoading || imageLoading" :class="$inputError('title', validationErrors)" :placeholder="$t('onsiteUtilities.digitalCertificate.certificateNamePlaceholder')" class="custom-input-width" prefix-icon="fas fa-pen">
              <template slot="suffix">
                <el-tooltip effect="dark" placement="top-start">
                  <div class="tooltip-wrapper" slot="content">{{ $t("onsiteUtilities.digitalCertificate.certificateName") }}</div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
            </el-input>
          </li>
          <li class="nav-item custom-nav-item-cont">
            <el-date-picker :format="datePickerDisplayFormat()" size="medium" :disabled="loading || backgroundLoading || imageLoading" v-model="canvas.expireDate" type="date" :placeholder="$t('onsiteUtilities.digitalCertificate.expriryDatePlaceholder')" class="custom-input-width" prefix-icon="fas fa-calendar"></el-date-picker>
            <div class="custom-suffix">
              <el-tooltip effect="dark" placement="top-start">
                <div class="tooltip-wrapper" slot="content">{{ $t("onsiteUtilities.digitalCertificate.expriryDate") }}</div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </li>
          <li class="nav-item">
            <el-popconfirm :confirm-button-text="$t('event.variables.yes')" :cancel-button-text="$t('event.variables.no')" icon="el-icon-info" @confirm="$router.push({ name: 'certificates' })" :title="$t('information.sureToBack')">
              <el-button type="warning" icon="el-icon-close" size="mini" :disabled="loading || backgroundLoading || imageLoading" round slot="reference">{{ $t("onsiteUtilities.digitalCertificate.cancel") }}</el-button>
            </el-popconfirm>
          </li>
          <li class="nav-item">
            <el-popconfirm @confirm="save" :confirm-button-text="$t('event.variables.yes')" :cancel-button-text="$t('event.variables.no')" icon="el-icon-info" :title="$t('onsiteUtilities.digitalCertificate.saveSure')">
              <el-button type="primary" size="mini" round slot="reference" :disabled="loading || backgroundLoading || imageLoading" :icon="loading ? 'el-icon-loading' : 'el-icon-picture'">{{ $t("onsiteUtilities.digitalCertificate.save") }}</el-button>
            </el-popconfirm>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <el-row :gutter="10" class="mb-3 mt-3 p-2">
            <el-col :span="24" class="top-info-input align-items-center d-flex">
              <el-button size="medium" icon="fas fa-pen" @click="addText($t('editText'))">{{ this.$t("event.buttons.addText") }}</el-button>
              <el-upload :before-upload="beforeImageUpload" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=certificate&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="imageSuccess">
                <el-button size="medium" :disabled="imageLoading" :icon="imageLoading ? 'el-icon-loading' : 'el-icon-camera-solid'">{{ this.$t("event.buttons.addImg") }}</el-button>
              </el-upload>

              <el-upload :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=certificate&language=' + $i18n.locale" :before-upload="beforeBackgroundUpload" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="backgroundSuccess">
                <el-button size="medium" :disabled="backgroundLoading" :icon="backgroundLoading ? 'el-icon-loading' : 'el-icon-picture'">{{ this.$t("event.buttons.changeBackground") }}</el-button>
              </el-upload>
              <el-select v-model="addedObj" filterable v-if="groups.length > 0" size="small" :placeholder="$t('event.buttons.var')" style="background-color:white;max-width:400px">
                <el-option-group v-for="(group, groupIndex) in groups" :key="groupIndex + '-dynamicGroup'" :label="group">
                  <el-option v-for="item in dynamicParams.filter(x => x.group == group)" :key="item.key" :label="item.title" :value="item.key"></el-option>
                </el-option-group>
              </el-select>
              <!-- <el-dropdown @command="addVar" style="display: flex; align-items: center; margin-right: 5px">
                <el-button size="medium" icon="el-icon-arrow-down">{{ this.$t("event.buttons.var") }}</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="'FirstName'">{{ $t("event.table.firstname") }}</el-dropdown-item>
                  <el-dropdown-item :command="'LastName'">{{ $t("event.table.lastname") }}</el-dropdown-item>
                  <el-dropdown-item :command="'ParticipantNO'">{{ $t("event.table.participantNO") }}</el-dropdown-item>
                  <el-dropdown-item :command="'CertificateNO'">{{ $t("event.table.certNO") }}</el-dropdown-item>
                  <el-dropdown-item :command="item.printerParam" :key="item.id" v-for="item in registrationInputs">{{ item.title }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </el-col>
          </el-row>

          <div id="_designer_wrapper">
            <div id="_toolbar">
              <TextToolbar :data="getActiveElement" v-if="getActiveElement && getActiveElement.type == 'text'" :fonts="fonts" @add-history="addHistory" />
            </div>
            <div id="_scene">
              <div :style="getCanvasStyle" id="_canvas">
                <div class="objectx"></div>
                <div class="objecty"></div>
                <template v-for="element in canvas.elements">
                  <DesignerText @TextChanged="textChanged" @PositionUpdated="positionUpdated" @SizeUpdated="sizeUpdated" @StartEditing="startEditing" @StopEditing="stopEditing" @SetActiveElement="setActiveElement" v-if="element.type == 'text'" :data="element" :key="element.id + historyDate" :isActive="getActiveElement.id == element.id" />
                  <DesignerImage @PositionUpdated="positionUpdated" @SizeUpdated="sizeUpdated" @StartEditing="startEditing" @StopEditing="stopEditing" @SetActiveElement="setActiveElement" v-if="element.type == 'image'" :data="element" :key="element.id + historyDate" :isActive="getActiveElement.id == element.id" />
                </template>
              </div>
            </div>
            <div id="_zoomController" class="mt-2">
              <el-input-number size="mini" v-model="canvas.zoom" :min="1" :max="2" :step="0.1" style="margin-right: 10px"> </el-input-number>

              <el-button-group style="margin-right: 10px">
                <el-button size="mini" circle icon="fas fa-trash" @click="deleteItem(getActiveElement.id)" v-if="getActiveElement.id"></el-button>

                <el-button size="mini" icon="fas fa-angle-down" :disabled="getActiveElement.zIndex == 1" @click="bringBack(getActiveElement.id)" v-if="getActiveElement.id"></el-button>

                <el-button circle size="mini" icon="fas fa-angle-up" :disabled="getActiveElement.zIndex == canvas.elements.length" @click="bringForward(getActiveElement.id)" v-if="getActiveElement.id"></el-button>
                <el-button circle size="mini" icon="fas fa-copy" :disabled="activeElement == null" @click="duplicateActiveElement"></el-button>
                <el-button circle size="mini" icon="fas fa-undo-alt" :disabled="canvas.history.length == 0" @click="prevHistory(getActiveElement.id)"></el-button>
              </el-button-group>

              <el-input-number style="width: 100px; margin-right: 5px;" size="mini" v-model="canvas.width" :min="200" :max="1000"></el-input-number>
              <el-input-number size="mini" style="width: 100px;margin-right: 5px;" v-model="canvas.height" :min="200" :max="1000"></el-input-number>

              <el-button
                size="mini"
                @click="
                  canvas = {
                    ...canvas,
                    width: canvas.height,
                    height: canvas.width
                  }
                "
              >
                {{ canvas.width > canvas.height ? $t("vertical") : $t("horizontal") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import DesignerText from "@/components/DesignerText";
import DesignerImage from "@/components/DesignerImage";
import TextToolbar from "@/components/toolbar/TextToolbar";
import axios from "axios";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  metaInfo: {
    title: "Certificate designer"
  },
  name: "HolaconDesigner",
  components: { DesignerText, TextToolbar, DesignerImage, quillEditor },
  data() {
    return {
      imageLoading: false,
      saveModal: false,
      loading: false,
      validationErrors: [],
      variables: [
        {
          title: this.$t("event.table.firstname"),
          value: "%recipient.FirstName%"
        },
        {
          title: this.$t("event.table.lastname"),
          value: "%recipient.LastName%"
        },
        {
          title: this.$t("event.table.participantID"),
          value: "%recipient.ParticipantNO%"
        },
        {
          title: this.$t("event.table.activationCode"),
          value: "%recipient.ActivationCode%"
        }
      ],
      registrationInputs: [],
      axios,
      historyDate: new Date().getTime(),
      canvas: {
        width: 842,
        height: 595,
        zoom: 1,
        elements: [
          {
            width: 500,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 49,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#0A658C",
            type: "text",
            position: "absolute",
            left: 171,
            top: 135,
            editable: false,
            content: this.$t("event.tags.participationCert"),
            zIndex: 1,
            id: "ef910e62-eb89-4e68-9ae8-71f9396c493f",
            height: 67
          },
          {
            width: 491,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 16,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#173D4E",
            type: "text",
            position: "absolute",
            left: 175.5,
            top: 230,
            editable: false,
            content: this.$t("event.textbox.certAppeal"),
            zIndex: 1,
            id: "876d2d5d-59db-44c0-b65f-0e7921cb72a0",
            height: 24
          },
          {
            width: 606,
            textAlign: "center",
            fontWeight: "normal",
            fontSize: 13,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#173D4E",
            type: "text",
            position: "absolute",
            left: 124.5,
            top: 282,
            editable: false,
            content: this.$t("event.textbox.certNote"),
            zIndex: 1,
            id: "86587323-8436-4178-9cff-59c880ce2cbe",
            height: 77
          },
          {
            width: 144,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 16,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#173D4E",
            type: "text",
            position: "absolute",
            left: 124.5,
            top: 382,
            editable: false,
            content: "John Doe",
            zIndex: 1,
            id: "0d69b1a9-95f0-4ef4-a93c-7eff11bb09a8",
            height: 23
          },
          {
            width: 142.43748415290767,
            left: 574.992125,
            top: 413,
            zIndex: 5,
            content: "https://holacon.s3.eu-central-1.amazonaws.com/5e2b3b73286bd618b47d1e6e/5e2b3b73286bd618b47d1e6d/5e30227b83089521b86ef7bf/certificate/d1db3267-fb74-4e8d-a953-2da4fbcfc069.png",
            type: "image",
            position: "absolute",
            id: "0499aa4e-12bc-4473-b5e9-f04b0a886663",
            height: 64.094
          },
          {
            width: 144,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 16,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#173D4E",
            type: "text",
            position: "absolute",
            left: 574.211,
            top: 382,
            editable: false,
            content: "Garry Cooper",
            zIndex: 1,
            id: "4c44981a-789f-46ad-9562-7b5c71170cdc",
            height: 23
          },
          {
            width: 135.33333333333331,
            left: 128.836,
            top: 413,
            zIndex: 7,
            content: "https://holacon.s3.eu-central-1.amazonaws.com/5e2b3b73286bd618b47d1e6e/5e2b3b73286bd618b47d1e6d/5e30227b83089521b86ef7bf/certificate/bea0dc58-5ca7-43c1-98d7-29e094102d58.png",
            type: "image",
            position: "absolute",
            id: "8d46cb03-e427-49b4-8b82-24edbf08856e",
            height: 50.75
          },
          {
            width: 144,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 16,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#173D4E",
            type: "text",
            position: "absolute",
            left: 349,
            top: 440.75,
            editable: false,
            content: this.$moment(new Date()).format('DD.MM.yyyy'),
            zIndex: 1,
            id: "510253e5-dac3-4a83-a02b-3163ade4995e",
            height: 23
          },
          {
            width: 250,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 16,
            fontFamily: "Farro",
            textDecoration: "none",
            fontStyle: "normal",
            color: "#173D4E",
            type: "text",
            position: "absolute",
            left: 302.5,
            top: 477.0938,
            editable: false,
            content: "%certificate.certificateNo%",
            zIndex: 1,
            id: "2691fb9a-a019-4e2c-aeb0-e6b44c54d14b",
            height: 29
          }
        ],
        background: "https://holacon.s3.eu-central-1.amazonaws.com/5e2b3b73286bd618b47d1e6e/5e2b3b73286bd618b47d1e6d/5e30227b83089521b86ef7bf/certificate/386e7cd6-fd7b-4ecb-b19e-0d4bad2d84eb.jpg",
        history: [],
        title: this.$t("event.tags.participationCert"),
        id: null,
        expireDate: null
      },
      textTemplate: {
        width: 300,
        textAlign: "center",
        fontWeight: "normal",
        fontSize: 18,
        fontFamily: "Roboto",
        textDecoration: "none",
        fontStyle: "normal",
        color: "#333",
        type: "text",
        position: "absolute",
        left: 0,
        top: 0,
        editable: false,
        content: this.$i18n.t("editText"),
        zIndex: 1
      },
      addedObj: null,
      imageTemplate: {
        width: 300,
        left: 0,
        top: 0,
        zIndex: 1,
        content: "",
        type: "image",
        position: "absolute"
      },
      activeElement: null,
      fonts: [],
      backgroundLoading: false,
      groups: [],
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ align: [] }], ["clean"], ["link"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      }
    };
  },
  methods: {
    duplicateActiveElement() {
      var element = JSON.parse(JSON.stringify(this.getActiveElement));

      element = {
        ...element,
        left: 0,
        top: 0,
        id: uuidv4()
      };

      this.canvas.elements.push(element);
    },
    beforeImageUpload() {
      this.imageLoading = true;
    },
    beforeBackgroundUpload() {
      this.backgroundLoading = true;
    },
    addVar2(variable) {
      var selection = this.$refs.editor.quill.getSelection();
      var index;
      if (selection == null) {
        if (this.canvas.emailMessageBody == null) {
          index = 0;
        } else {
          index = this.canvas.emailMessageBody.length;
        }
      } else {
        index = selection.index;
      }
      this.$refs.editor.quill.insertText(index, " " + variable + " ");
    },
    addVar(item) {
      this.addText("%recipient." + item + "%");
    },

    backgroundSuccess(response) {
      this.backgroundLoading = false;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.canvas.background = response.data.item.url;
      }
    },
    imageSuccess(response) {
      this.imageLoading = false;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.addImage(response.data.item.url);
      }
    },
    async save() {
      if (this.loading != null) clearTimeout(this.listShort);
      this.loading = true;
      var res = await axios.post("Certificate/AddOrUpdate", {
        id: this.canvas.id,
        title: this.canvas.title,
        details: $("#_scene").html(),
        jsonData: JSON.stringify(this.canvas),
        expireDate: this.canvas.expireDate
      });

      this.validationErrors = res.data.validationErrors;
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
      } else {
        this.$message.success(res.data.alert.message);
        var jsonData = JSON.parse(res.data.data.item.jsonData);
        this.canvas.id = res.data.data.item.id;
        this.canvas.title = res.data.data.item.title;
        this.canvas.expireDate = res.data.data.item.expireDate;
      }

      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    textChanged({ id, text }) {
      var index = this.canvas.elements.findIndex(k => k.id == id);

      this.canvas.elements[index].content = text;
    },
    bringBack(id) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      var targetIndex = this.canvas.elements.findIndex(k => k.zIndex == this.canvas.elements[index].zIndex - 1);
      this.canvas.elements[index].zIndex -= 1;
      this.canvas.elements[targetIndex].zIndex += 1;
    },
    bringForward(id) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      var targetIndex = this.canvas.elements.findIndex(k => k.zIndex == this.canvas.elements[index].zIndex + 1);
      this.canvas.elements[index].zIndex += 1;
      this.canvas.elements[targetIndex].zIndex -= 1;
    },
    deleteItem(id) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      this.setActiveElement(null);
      this.canvas.elements.splice(index, 1);
    },
    prevHistory() {
      this.canvas.history.splice(this.canvas.history.length - 1, 1);
      this.$set(this, "canvas", {
        ...JSON.parse(JSON.stringify(this.canvas.history[this.canvas.history.length - 1])),
        history: JSON.parse(JSON.stringify(this.canvas.history))
      });

      this.historyDate = new Date().getTime();
    },
    addHistory() {
      this.canvas.history.push({
        ...JSON.parse(JSON.stringify(this.canvas)),
        history: []
      });
    },
    setActiveElement(id) {
      this.activeElement = id;
    },
    startEditing(id) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.canvas.elements, index, {
        ...this.canvas.elements[index],
        editable: true
      });
    },
    stopEditing(id) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.canvas.elements, index, {
        ...this.canvas.elements[index],
        editable: false
      });
    },
    positionUpdated({ position, id }) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.canvas.elements, index, {
        ...this.canvas.elements[index],
        left: position.position.left,
        top: position.position.top
      });
      this.addHistory();
    },
    sizeUpdated({ size, id }) {
      var index = this.canvas.elements.findIndex(k => k.id == id);
      this.$set(this.canvas.elements, index, {
        ...this.canvas.elements[index],
        width: size.size.width,
        height: size.size.height
      });
      this.addHistory();
    },
    addText(text) {
      this.canvas.elements.push({
        ...this.textTemplate,
        id: uuidv4(),
        zIndex: this.canvas.elements.length + 1,
        content: text
      });
    },
    addImage(image) {
      this.canvas.elements.push({
        ...this.imageTemplate,
        id: uuidv4(),
        zIndex: this.canvas.elements.length + 1,
        content: image
      });
    }
  },
  async created() {
    // axios.post('registrationinput/load', {}).then((res) => {
    //   this.registrationInputs = res.data.data.items;
    //   this.registrationInputs.map((k) => {
    //     this.variables.push({
    //       title: k.title,
    //       value: '%recipient.' + k.printerParam + '%',
    //     });
    //   });
    // });
    if (this.$route.params.id) {
      var res = await axios.post("certificate/get", { id: this.$route.params.id });
      var canvas = JSON.parse(res.data.data.item.jsonData);
      this.canvas = canvas;
      this.canvas.id = this.$route.params.id;
    }
  },
  async mounted() {
    //this.$refs.editor.quill.root.setAttribute("data-placeholder", this.$t('enterText'));

    var res = await axios.post("certificate/listfonts", { skip: 0, take: 1000 });
    await this.$store.dispatch("getDynamicParams", { type: 16, isPrintScheme: false });
    this.groups = this.dynamicParams.map(x => {
      return x.group;
    });
    this.groups = [...new Set(this.groups)];
    this.fonts = res.data.data.items;
    console.log(this.fonts);
    this.fonts.map(k => {
      var head = document.getElementsByTagName("head")[0];
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = k.url;
      head.appendChild(link);
    });
  },
  watch: {
    addedObj: function(newVal) {
      if (this.addedObj != null) {
        if (this.addedObj == "123456") {
          // tinymce.activeEditor.insertContent("<img width='100' height='100' src='https://api.holacon.com/v1/Home/GetQRImage/GetQR/" + variable + "' />");
          this.canvas.elements.push({
            ...this.imageTemplate,
            id: uuidv4(),
            zIndex: this.canvas.elements.length + 1,
            content: "https://api.holacon.com/v2/Home/GetQRImage?qrText=" + this.addedObj
          });
        } else {
          this.addText(this.addedObj);
        }
        this.addedObj = null;
      }
    }
  },
  computed: {
    dynamicParams() {
      return this.$store.getters.getDynamicParams;
    },
    getCanvasStyle() {
      return {
        width: this.canvas.width + "px",
        height: this.canvas.height + "px",
        transform: "scale(" + this.canvas.zoom + ")",
        position: "relative",
        backgroundImage: "url(" + this.canvas.background + ")",
        backgroundSize: "100% 100%"
      };
    },
    getActiveElement() {
      if (this.activeElement == null) return {};
      return this.canvas.elements.find(k => k.id == this.activeElement);
    }
  }
};
</script>

<style lang="less" scoped>
@import url(https://ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/themes/base/jquery-ui.css);
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
}
#_designer_wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#_scene {
  display: flex;
  flex: 1;
  overflow: auto;
  align-items: center;
  justify-content: center;
}

#_canvas {
  background-color: #fff;
  transition: 0.3s;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.35);
  position: relative;
  margin: 30px 0px;
}

#_toolbar {
  padding: 5px 10px;
  margin: 0 auto;
  width: 100%;
  height: 40px;
}

#_zoomController {
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

#_designer_wrapper ._designer-element {
  border: 1px dotted #ddd;
  cursor: move;
}

#_designer_wrapper ._designer-element.active {
  border: 1px solid aqua;
  cursor: move;
}
#_toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.object1 {
  background: #aaa;
  width: 100px;
  height: 100px;
  display: block;
  position: absolute;
  left: 140px;
  top: 50px;
}
.object2 {
  background: #aaa;
  width: 100px;
  height: 150px;
  display: block;
  position: absolute;
  left: 140px;
  top: 50px;
}
.object3 {
  background: #aaa;
  width: 150px;
  height: 100px;
  display: block;
  position: absolute;
  left: 140px;
  top: 50px;
}
.objectx {
  display: none;

  width: 0px;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 10px;
  border-left: 1px dashed blue;
}
.objecty {
  display: none;
  width: 100%;
  height: 0px;
  position: absolute;
  top: 10px;
  left: 0px;
  border-bottom: 1px dashed blue;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: 1 !important;
  background-image: none;
}

.ui-resizable-handle.ui-icon {
  border: none !important;
}
.top-info-input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
  .el-input {
    width: 250px;
  }
}

#certificate-addorupdate {
  .content {
    .card {
      background: transparent !important;
      box-shadow: unset;
    }
  }
}

.custom-nav-item-cont {
  position: relative;
  .custom-suffix {
    position: absolute;
    right: 5px;
    top: 8px;
    i {
      font-size: 13px;
      color: #292f3b;
      font-weight: 600;
    }
  }
}
.custom-input-width {
  min-width: 240px;
  & > .el-icon__suffix-inner {
    margin-right: 1rem;
  }
}
</style>
<style>
.el-input__suffix {
  display: flex;
  align-items: center;
}
.el-input__suffix i {
  font-size: 13px;
  color: #292f3b;
  font-weight: 600;
}
.ui-icon-gripsmall-diagonal-se {
  background-position: -67px -222px !important;
}

.ui-resizable-handle.ui-icon {
  border-color: transparent transparent transparent transparent !important;
}
.custom-input-width .el-input__suffix-inner {
  margin-right: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/AddUpdateCertificate.vue